import * as yup from 'yup';

export const setHoraInicioFinPyLOTSchema = yup.object({
  // tipo_servicio: yup.string().required('El tipo de servicio es requerido'),
  // ciudad: yup.string().required('La ciudad es requerida'),
  // sector: yup
  //   .number()
  //   .typeError('El sector es requerido')
  //   .required('El sector es requerido'),
  // zona: yup
  //   .number()
  //   .typeError('La zona es requerida')
  //   .required('La zona es requerida'),
  // plan: yup
  //   .number()
  //   .typeError('El plan es requerido')
  //   .required('El plan es requerido'),
  // nap: yup.string().required('El NAP es requerido'),
  // puerto: yup
  //   .number()
  //   .typeError('El puerto es requerido')
  //   .required('El puerto es requerido')
  //   .min(1, 'Puerto inválido'),

  // direccion_ip: yup.string().required('La dirección IP es requerida'),
  // router_ac: yup.string().required('El router AC es requerido'),
  // observacion: yup.string().optional(),
  // numero_documento: yup
  //   .string()
  //   .required('El número de documento es requerido'),
  // tipo_instalacion: yup
  //   .string()
  //   .required('El tipo de instalación es requerido'),
  // user: yup
  //   .number()
  //   .typeError('El usuario es requerido')
  //   .required('El usuario es requerido'),

  hora_inicio: yup.string().required('La hora de inicio es requerida'),
  hora_fin: yup.string().required('La hora de fin es requerida'),
});
